import CheckIcon from '@mui/icons-material/Check'
import CloudOffIcon from '@mui/icons-material/CloudOff'
import {Avatar, Box, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {KMS_WIDGET_NAMESPACE} from '../../../consts'

export const NoTelemetryData = () => {
  const {t} = useTranslation(KMS_WIDGET_NAMESPACE)

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: 200,
        gap: 1
      }}
    >
      <Avatar sx={{width: 64, height: 64, bgcolor: '#F7F9FA'}}>
        <CloudOffIcon fontSize="medium" sx={{color: '#668099'}} />
      </Avatar>
      <Typography variant="caption" sx={{color: '#52667A'}}>
        {t('assetHealth.noData')}
      </Typography>
    </Box>
  )
}

export const NoAlarms = () => {
  const {t} = useTranslation(KMS_WIDGET_NAMESPACE)

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: 200,
        gap: 1
      }}
    >
      <Avatar sx={{width: 64, height: 64, bgcolor: '#F2FBF6'}}>
        <CheckIcon fontSize="medium" sx={{color: 'success.light'}} />
      </Avatar>
      <Typography variant="caption" sx={{color: '#52667A'}}>
        {t('assetHealth.noAlarms')}
      </Typography>
    </Box>
  )
}
